/** Name of an environment variable that is pulled from the backend. */
export enum EnvironmentKey {
  authTokenRefreshCountLimit = 'REACT_AUTH_TOKEN_REFRESH_COUNT_LIMIT'
}
